// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getCompanyActionsReducer } from './getCompanyActions';
import { reducer as companyShowFormReducer } from './companyShowForm';
import { reducer as changeCompanyActionsReducer } from './changeCompanyActions';
import { reducer as changeCompanyReducer } from './changeCompany';
import { reducer as getFrui_zzzzListReducer } from './getFrui_zzzzList';
import { reducer as submitFrui_zzzzReducer } from './submitFrui_zzzz';
import { reducer as deleteFrui_zzzzReducer } from './deleteFrui_zzzz';
import { reducer as frui_zzzzModalChangeReducer } from './frui_zzzzModalChange';
import { reducer as chooseCurrentFrui_zzzzReducer } from './chooseCurrentFrui_zzzz';
import { reducer as getFrui_qpfjListReducer } from './getFrui_qpfjList';
import { reducer as submitFrui_qpfjReducer } from './submitFrui_qpfj';
import { reducer as deleteFrui_qpfjReducer } from './deleteFrui_qpfj';
import { reducer as frui_qpfjModalChangeReducer } from './frui_qpfjModalChange';
import { reducer as chooseCurrentFrui_qpfjReducer } from './chooseCurrentFrui_qpfj';
import { reducer as getFrui_qpbzListReducer } from './getFrui_qpbzList';
import { reducer as submitFrui_qpbzReducer } from './submitFrui_qpbz';
import { reducer as deleteFrui_qpbzReducer } from './deleteFrui_qpbz';
import { reducer as frui_qpbzModalChangeReducer } from './frui_qpbzModalChange';
import { reducer as chooseCurrentFrui_qpbzReducer } from './chooseCurrentFrui_qpbz';
import { reducer as getFrui_qpxhListReducer } from './getFrui_qpxhList';
import { reducer as submitFrui_qpxhReducer } from './submitFrui_qpxh';
import { reducer as deleteFrui_qpxhReducer } from './deleteFrui_qpxh';
import { reducer as frui_qpxhModalChangeReducer } from './frui_qpxhModalChange';
import { reducer as chooseCurrentFrui_qpxhReducer } from './chooseCurrentFrui_qpxh';
import { reducer as getFrui_pfbzListReducer } from './getFrui_pfbzList';
import { reducer as submitFrui_pfbzReducer } from './submitFrui_pfbz';
import { reducer as deleteFrui_pfbzReducer } from './deleteFrui_pfbz';
import { reducer as frui_pfbzModalChangeReducer } from './frui_pfbzModalChange';
import { reducer as chooseCurrentFrui_pfbzReducer } from './chooseCurrentFrui_pfbz';
import { reducer as getFrui_pfxhListReducer } from './getFrui_pfxhList';
import { reducer as submitFrui_pfxhReducer } from './submitFrui_pfxh';
import { reducer as deleteFrui_pfxhReducer } from './deleteFrui_pfxh';
import { reducer as frui_pfxhModalChangeReducer } from './frui_pfxhModalChange';
import { reducer as chooseCurrentFrui_pfxhReducer } from './chooseCurrentFrui_pfxh';
import { reducer as chooseCurrentFruiZzzzModelShowReducer } from './chooseCurrentFruiZzzzModelShow';
import { reducer as fruiPfxhtypeTestsModalChangeReducer } from './fruiPfxhtypeTestsModalChange';
import { reducer as submitFruiPfxhTypeTestsReducer } from './submitFruiPfxhTypeTests';
import { reducer as changeCurrentFruiPfxhTypeTestsReducer } from './changeCurrentFruiPfxhTypeTests';
import { reducer as uploadingYyzzActionsReducer } from './uploadingYyzzActions';
import { reducer as uploadingSealActionsReducer } from './uploadingSealActions';
import { reducer as uploadingXkzActionsReducer } from './uploadingXkzActions';
import { reducer as getAllQppzListReducer } from './getAllQppzList';
import { reducer as getAllMakeUnitActionsReducer } from './getAllMakeUnitActions';
import { reducer as getQueryQpxxIdActionsReducer } from './getQueryQpxxIdActions';
import { reducer as hadleTongBuActionsReducer } from './hadleTongBuActions';
import { reducer as getTempFileListActionReducer } from './getTempFileListAction';
import { reducer as delTempFileActionReducer } from './delTempFileAction';
import { reducer as addTempFileActionReducer } from './addTempFileAction';
import { reducer as showAddModalReducer } from './showAddModal';
import { reducer as getFrui_qppzListReducer } from './getFrui_qppzList';
import { reducer as submitFrui_qppzReducer } from './submitFrui_qppz';
import { reducer as deleteFrui_qppzReducer } from './deleteFrui_qppz';
import { reducer as frui_qppzModalChangeReducer } from './frui_qppzModalChange';
import { reducer as chooseCurrentFrui_qppzReducer } from './chooseCurrentFrui_qppz';

const reducers = [
  getFrui_qppzListReducer,
  submitFrui_qppzReducer,
  deleteFrui_qppzReducer,
  frui_qppzModalChangeReducer,
  chooseCurrentFrui_qppzReducer,
  getFrui_pfxhListReducer,
  submitFrui_pfxhReducer,
  deleteFrui_pfxhReducer,
  frui_pfxhModalChangeReducer,
  chooseCurrentFrui_pfxhReducer,
  getFrui_pfbzListReducer,
  submitFrui_pfbzReducer,
  deleteFrui_pfbzReducer,
  frui_pfbzModalChangeReducer,
  chooseCurrentFrui_pfbzReducer,
  getFrui_qpxhListReducer,
  submitFrui_qpxhReducer,
  deleteFrui_qpxhReducer,
  frui_qpxhModalChangeReducer,
  chooseCurrentFrui_qpxhReducer,
  getFrui_qpbzListReducer,
  submitFrui_qpbzReducer,
  deleteFrui_qpbzReducer,
  frui_qpbzModalChangeReducer,
  chooseCurrentFrui_qpbzReducer,
  getFrui_qpfjListReducer,
  submitFrui_qpfjReducer,
  deleteFrui_qpfjReducer,
  frui_qpfjModalChangeReducer,
  chooseCurrentFrui_qpfjReducer,
  getFrui_zzzzListReducer,
  submitFrui_zzzzReducer,
  deleteFrui_zzzzReducer,
  frui_zzzzModalChangeReducer,
  chooseCurrentFrui_zzzzReducer,
  getCompanyActionsReducer,
  companyShowFormReducer,
  changeCompanyActionsReducer,
  changeCompanyReducer,
  chooseCurrentFruiZzzzModelShowReducer,
  fruiPfxhtypeTestsModalChangeReducer,
  submitFruiPfxhTypeTestsReducer,
  changeCurrentFruiPfxhTypeTestsReducer,
  uploadingYyzzActionsReducer,
  uploadingSealActionsReducer,
  uploadingXkzActionsReducer,
  getAllQppzListReducer,
  getAllMakeUnitActionsReducer,
  getQueryQpxxIdActionsReducer,
  hadleTongBuActionsReducer,
  getTempFileListActionReducer,
  delTempFileActionReducer,
  addTempFileActionReducer,
  showAddModalReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/user/redux/reducer.js